"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTestClientPayload = addTestClientPayload;
exports.getDefaultClientPayload = getDefaultClientPayload;
exports.getTestClientPayload = getTestClientPayload;
exports.resetTestClientPayload = resetTestClientPayload;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getDefaultClientPayload() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _opt$loggedIn = opt.loggedIn,
    loggedIn = _opt$loggedIn === void 0 ? false : _opt$loggedIn;
  var user = {
    userId: '1',
    isAuthenticated: loggedIn
  };
  if (loggedIn) {
    user = {
      id: '63949403',
      username: 'joel_basic',
      date_joined: '2018-10-17T16:23:00+00:00',
      date_subscribed: null,
      group: null,
      group_membership: null,
      hipaa: {
        is_hipaa_enabled: false
      },
      isAuthenticated: loggedIn,
      data_center: {
        data_center_id: 0,
        data_center_region_code: 'US',
        data_center_region_name: 'The United States of America'
      },
      language: {
        language_id: '1',
        language_name: 'English'
      }
    };
  }
  return {
    user: user,
    'client-config': {
      graphQLUri: '/graphql',
      graphQLUriAnonymous: '/lo-graphql',
      loggingAPIPath: null,
      dataAnalyticsAPIPath: null,
      mobileBannerDownloadLink: 'https://bnc.lt/ED1d/CFfW4z3t6B'
    },
    environment: {
      countryCode: 'US',
      languageCode: 'en',
      slLanguageLocale: 'en-US',
      ip: '127.0.0.1',
      subdomain: 'www',
      domain: 'monkeytest3',
      tld: 'com',
      languageId: 1
    },
    locale: {
      isEUSubdomain: false,
      isEUDC: false
    },
    GDPR: {
      isGDPRCountry: false,
      hasGDPRConsent: true,
      hasExplictlyDenied: false,
      onetrustBannerEnabled: false,
      fidesBannerEnabled: false
    },
    gql: {
      gqlCache: {}
    }
  };
}
function getTestClientPayload() {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    loggedIn: false
  };
  return (0, _deepmerge.default)(getDefaultClientPayload(opt), extra);
}
function addTestClientPayload() {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    loggedIn: false
  };
  window.SM = _objectSpread(_objectSpread({}, window.SM), getTestClientPayload(extra, opt));
}

/**
 * @private
 */
function resetTestClientPayload() {
  window.SM = {};
}
//# sourceMappingURL=index.js.map